module.exports = __webpack_public_path__ + "static/media/3.ec3c02fd.svg";